/* ---------------------------------------------------------------------------
 * Galería multimedia del producto - autoplay de videos
 *
 * El atributo autoplay por sí solo no basta: el theme mantiene los slides
 * inactivos en el DOM con visibility:hidden (fader desktop/mobile-thumbs), y
 * los navegadores no reanudan la reproducción al volverlos visibles. Además,
 * sin control explícito, todos los videos de la galería reproducirían a la vez.
 *
 * Regla: un video reproduce solo si su slide está dentro del viewport Y no
 * tiene las clases de slide oculto que aplica el theme. Cubre los dos modos de
 * galería (fader por clases en desktop, scroll-snap en mobile).
 * ------------------------------------------------------------------------- */
(function () {
  'use strict';

  var SLIDE_SELECTOR = '[data-slide][data-video]';
  var HIDDEN_CLASSES = ['media--hidden', 'media--hiding'];
  var VISIBLE_FLAG = 'l51VideoVisible';

  function isHiddenSlide(slide) {
    for (var i = 0; i < HIDDEN_CLASSES.length; i++) {
      if (slide.classList.contains(HIDDEN_CLASSES[i])) return true;
    }
    return false;
  }

  function sync(slide) {
    var video = slide.querySelector('video');
    if (!video) return;

    var shouldPlay = slide.dataset[VISIBLE_FLAG] === 'true' && !isHiddenSlide(slide);

    if (shouldPlay) {
      if (video.paused) {
        var played = video.play();
        // Si el navegador rechaza el autoplay no hay nada que hacer: lo tragamos
        // para no ensuciar la consola con una promesa no capturada.
        if (played && typeof played.catch === 'function') played.catch(function () {});
      }
    } else if (!video.paused) {
      video.pause();
    }
  }

  var intersectionObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        entry.target.dataset[VISIBLE_FLAG] = entry.isIntersecting ? 'true' : 'false';
        sync(entry.target);
      });
    },
    { threshold: 0.5 }
  );

  // El theme alterna media--hidden/media--hiding al cambiar de slide.
  var classObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      sync(mutation.target);
    });
  });

  function register(slide) {
    if (slide.dataset.l51VideoBound === 'true') return;
    slide.dataset.l51VideoBound = 'true';
    intersectionObserver.observe(slide);
    classObserver.observe(slide, { attributes: true, attributeFilter: ['class'] });
  }

  function scan(root) {
    (root || document).querySelectorAll(SLIDE_SELECTOR).forEach(register);
  }

  function init() {
    scan(document);

    // La galería se re-renderiza al cambiar de variante (product-info).
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.matches && node.matches(SLIDE_SELECTOR)) register(node);
          else scan(node);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
